// 个人信息默认模板
export const defaultAboutInfoTemplate = {
  name: '未设置昵称',
  avatar: 'https://cn.bing.com/images/search?view=detailV2&ccid=3rQ0W4iv&id=E94363D4919EE5C5A729974F1F54D508937EF941&thid=OIP.3rQ0W4ivbnQcKt17I5ZNCgAAAA&mediaurl=https%3a%2f%2fc-ssl.dtstatic.com%2fuploads%2fblog%2f202306%2f04%2fd3S26N52IqMeglx.thumb.400_0.jpeg&exph=399&expw=400&q=%e5%8a%a8%e6%bc%ab%e5%a4%b4%e5%83%8f&FORM=IRPRST&ck=13A71EF72DF99151D2895CF589768BC2&selectedIndex=18&itb=0',
  intro: '这个人很神秘，什么也没留下。',
  details: '欢迎来到我的博客！请登陆后完善您的个人信息！',
  email: '未设置邮箱',
  techStack: '暂无',
  interests: '暂无',
  github: '#',
  linkedin: '#',
  personalHomepage: '#'
};

// 导出个人信息 mock 数据
export const mockAboutInfo = defaultAboutInfoTemplate;

// 从localStorage读取用户文章
let mockPosts = JSON.parse(localStorage.getItem('myBlogPosts')) || [];

// 保存文章到localStorage
const savePostsToLocal = () => {
  localStorage.setItem('myBlogPosts', JSON.stringify(mockPosts));
};

// 模拟文章接口
export const mockPostsApi = {
  posts: {
    getPosts: async (page, limit) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            success: true,
            data: { posts: [...mockPosts] }
          });
        }, 500);
      });
    },

    deletePost: async (postId) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          const targetPostId = typeof postId === 'number' ? `post_${postId}` : postId;
          const postExists = mockPosts.some(post => post.id === targetPostId);
          
          if (postExists) {
            mockPosts = mockPosts.filter(post => post.id !== targetPostId);
            savePostsToLocal();
            resolve({ success: true, message: '删除成功' });
          } else {
            resolve({ success: false, message: '文章不存在，删除失败' });
          }
        }, 300);
      });
    },

    getPostById: async (postId) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          const targetPostId = typeof postId === 'number' ? `post_${postId}` : postId;
          const post = mockPosts.find(p => p.id === targetPostId);
          
          if (post) {
            resolve({ success: true, data: { post } });
          } else {
            resolve({ success: false, message: '文章不存在' });
          }
        }, 300);
      });
    },

    savePost: async (postData) => {
      return new Promise((resolve) => {
        setTimeout(() => {
          if (postData.id) {
            mockPosts = mockPosts.map(post => 
              post.id === postData.id ? { ...post, ...postData } : post
            );
          } else {
            const newPostId = `post_${Date.now()}`;
            const newPost = {
              id: newPostId,
              date: new Date().toISOString().split('T')[0],
              likeCount: 0,
              commentCount: 0,
              ...postData
            };
            mockPosts.unshift(newPost);
          }
          savePostsToLocal();
          resolve({ success: true, message: postData.id ? '编辑成功' : '新增成功' });
        }, 300);
      });
    }
  }
};

export { mockPosts };
window.mockPostsApi = mockPostsApi;